<template>
  <div class="explore-container">
    <div class="layout-banner">
      <img
        class="pc-banner"
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/explore-banner.png"
        alt=""
      />
      <img
        class="mobile-banner"
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/mobile_layout_banner.png"
      />

      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          踏勘精灵APP
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          智能飞行 采集无忧
        </div>
        <div
          class="use-button wow fadeInUp"
          @click="openCodeDialog"
          data-wow-delay="0.7s"
        >
          申请试用
        </div>
      </div>
    </div>

    <div class="block-box" style="background-color: #f5f7fa">
      <div class="block-wrap desc-wrap">
        <div class="block-title page-block-title">产品简介</div>
        <div class="block-desc page-block-desc">
          踏勘精灵为辅助踏勘设计而生，集一键起飞、自主规划航线、自动飞行采数、断点续飞、自动返航、数据一键上传功能于一身。航飞系统简洁智能，辅助现场踏勘快速开展，高效踏勘一触即发
        </div>
        <div class="content-wrap">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img1.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- <div class="block-wrap airplane-wrap">
      <div class="block-title ">支持大疆全系列无人机，赋予无人机更多可能</div>
      <div class="block-content">
        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img2.png" alt="" />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">Min系列</div>
              <div class="desc">
                DJI Mini、DJI Mini2系列、DJI Mini 3、DJI Mini 3 Pro
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">Air系列</div>
              <div class="desc">DJI Air 、DJI Air 2系列</div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img3.png" alt="" />
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img4.png" alt="" />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">Mavic系列</div>
              <div class="desc">
                Mavic 2 系列、DJI Mavic 3 行业系列、DJI Mavic 3 多光谱版
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">精灵系列</div>
              <div class="desc">Phantom4精灵系列</div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img5.png" alt="" />
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img6.png" alt="" />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">经纬系列</div>
              <div class="desc">
                经纬MatriceM210、M300系列 、Matrice 30系列、Matrice 300
                RTK、Matrices 350 RTK
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="block-wrap">
      <div class="block-title page-block-title">智能飞行</div>
      <div class="block-content">
        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img7.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">二维弓字飞行</div>
              <div class="desc">
                飞行路径简单明了，飞行效率高，能够快速覆盖长距离或特定方向的目标区域。
              </div>
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="block-text">
              <div class="title">三维环绕飞行</div>
              <div class="desc">
                三维环绕飞行能够全方位、多角度地覆盖目标区域，提供立体、全面的视角。
              </div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img8.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="content-row">
          <div class="row-left wow fadeInLeft">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_img9.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">仿地飞行</div>
              <div class="desc">
                无人机实时感知地形特征并实时调整飞行高度，始终保持相对高度贴地飞行。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 无人机系列 -->
    <div class="airplane-wrap">
      <div class="block-title page-block-title">
        支持大疆全系列无人机，赋予无人机更多可能
      </div>
      <div class="airplane-content pc-airplane">
        <div
          class="content-item"
          :class="{ on: activeIndex == '1' }"
          @mouseover="expandItem('1')"
        >
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img1.png"
            alt=""
          />
          <div class="text-block">
            <div class="text-title">Mini系列</div>
            <div class="text-list">
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                DJI Mini
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                DJI Mini2系列
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                DJI Mini 3
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                DJI Mini 3 Pro
              </div>
            </div>
          </div>
        </div>
        <div
          class="content-item"
          :class="{ on: activeIndex == '2' }"
          @mouseover="expandItem('2')"
        >
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img2.png"
            alt=""
          />
          <div class="text-block">
            <div class="text-title">Air系列</div>
            <div class="text-list">
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                DJI Air
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                DJI Air 2系列
              </div>
            </div>
          </div>
        </div>
        <div
          class="content-item"
          :class="{ on: activeIndex == '3' }"
          @mouseover="expandItem('3')"
        >
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img3.png"
            alt=""
          />
          <div class="text-block">
            <div class="text-title">Mavic系列</div>
            <div class="text-list">
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                Mavic 2 系列
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                DJI Mavic 3 行业系列
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                DJI Mavic 3 多光谱版
              </div>
            </div>
          </div>
        </div>
        <div
          class="content-item"
          :class="{ on: activeIndex == '4' }"
          @mouseover="expandItem('4')"
        >
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img4.png"
            alt=""
          />
          <div class="text-block">
            <div class="text-title">精灵系列</div>
            <div class="text-list">
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                Phantom4精灵系列
              </div>
            </div>
          </div>
        </div>

        <div
          class="content-item"
          :class="{ on: activeIndex == '5' }"
          @mouseover="expandItem('5')"
        >
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img5.png"
            alt=""
          />
          <div class="text-block">
            <div class="text-title">经纬系列</div>
            <div class="text-list">
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                经纬MatriceM210
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                M300系列
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                Matrice 30系列
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                Matrice 300 RTK
              </div>
              <div class="list-item">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/check_icon.png"
                  alt=""
                />
                Matrices 350 RTK
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mobile-airplane">
        <airplaneCarousel></airplaneCarousel>
      </div>
    </div>

    <div class="mask" v-if="codeDialogFlag">
      <codeCard
        @closeDialog="closeDialog"
        :codeDialogFlag="codeDialogFlag"
      ></codeCard>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import codeCard from "./components/inspection-code.vue";
import airplaneCarousel from "./components/airplane-carousel.vue";

export default {
  components: {
    codeCard,
    airplaneCarousel,
  },
  data() {
    return {
      activeChoose: "simple",
      codeDialogFlag: false,
      activeIndex: "1",
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    closeDialog() {
      this.codeDialogFlag = false;
    },
    openCodeDialog() {
      this.codeDialogFlag = true;
    },
    expandItem(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="stylus" scoped>
.mask {
    width: 100%;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    background: rgba(0,0,0,0.7);
    display:flex;
    justify-content:center;
    z-index:15;
    align-items:center;
}
.airplane-wrap {
  max-width: var(--main-width);
  width: 84%;
  margin:0 auto 6.91rem;
  .block-title {
    position:relative;
    position:relative;
    text-align:center;
    letter-spacing:2px;
    font-weight:bold;
}
.mobile-airplane {
  display:none;
}

  .airplane-content {
    display:flex;
    overflow:hidden;
    margin-top:3.25rem;
    .content-item {
      width: 9.25%;
      flex: 1 0 9.25%;
      height:29.91rem;
      position:relative;
      transition: flex 0.3s ease, transform 0.3s ease;
      .text-block {
        position:absolute;
        left: 0;
        top: 0;
        padding: 2.75rem 0 0 2.88rem;
        color:#fff;
        .text-title {
          font-weight: 500;
          font-size: 1.63rem;
          color: #FFFFFF;
          line-height: 2.38rem;
          text-align: left;
          margin-bottom:1.56rem;
        }
        .list-item {
          margin-bottom:0.4rem;
          opacity:0;
          display:flex;
          align-items:center;
          img {
            width:14px;
            margin-right:0.38rem;
          }
        }
      }
    }
    .content-item img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      transition: object-position 0.3s ease;
  }
    .on {
      flex: 1 0 37.5% !important; /* 鼠标悬停时应用 .on 的样式 */
      .list-item {
        opacity:1 !important;
      }
    }

    .content-item.on img {
      object-position: 50% 50%; /* 可以根据实际情况调整，这里保持中间 */
  }
  }
}
.explore-container {
    width:100%;
    @keyframes zoomIn {
            0% {
              transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
    .layout-banner {
        height:100vh;
        position:relative;
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;

        }
        .mobile-banner {
          display:none;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:13%;
            transform: translateY(-50%);
            z-index: 2;
            color:#fff;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:625px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
            .use-button {
                width:9rem;
                height:2.875rem;
                font-size:1.125rem;
                letter-spacing:1px;
                cursor:pointer;
                background: #2372E9;
                line-height:2.875rem;
                text-align:center;
                margin-top:6.18rem;
                border-radius:30px;
            }
        }
    }
    .content-wrap {
        max-width: var(--main-width);
        width: 84%;
        margin:0 auto;
        padding-bottom:5.8rem;
        text-align:center;
        img {
            width:500px;
        }
    }
    .block-wrap {
        max-width:var(--main-width);
        width:84%;
        margin:0 auto;
        position:relative;
        padding:4.625rem 4rem 5.56rem;
        .block-title {
            position:relative;
            position:relative;
            text-align:center;
            letter-spacing:2px;
            font-weight:bold;
        }
            .block-desc {
                margin:4.625rem auto 3.75rem;
                line-height:32px;
                text-align:center;
            }
    }

    .block-content {
        max-width: var(--main-width);
        margin:7.56rem auto 0;
        .content-row {
            display:flex;
            margin-bottom:4rem;
            >div {
                flex:1;
            }
            .block-text {
                padding:3rem 5.5rem;
                .title {
                    color:#2372E9;
                    margin-bottom:3.18rem;
                    font-size:1.75rem;
                    font-weight:bold;
                }
                .desc {
                    color:#333333;
                    line-height:30px;
                    font-size:1rem;
                }
            }
        }
    }
    .block-content-box {
        max-width: var(--main-width);
        width: 84%;
        margin:0 auto;
        .block-content-title {
            text-align:center;
            position:relative;
            font-size:2.625rem;
            position:relative;
            text-align:center;
            letter-spacing:2px;
            font-weight:bold;
        }
        .block-content-title::after {
            content:"";
            position:absolute;
            width: 55px;
            left:50%;
            transform:translateX(-50%);
            top:80px;
            height: 3px;
            background: #2372E9;
            }
        }
        .block-content-bg {

            margin:4.5rem auto;
            width:100%;
            display:flex;
            justify-content: center;
        }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
    .content-row {
        flex-wrap:wrap;
        .img-wrap {
            height:425px;
            overflow:hidden;
            // img {
            //     width:100%;
            // }
        }
        .row-left,.row-right {
            width:100%;
            flex:auto !important;
        }
    }
}
@media only screen and (max-width: 768px) {
  .content-row:nth-child(2) {
     margin-bottom:60px !important;
  }
    .content-row {
        flex-wrap:wrap;
        margin-bottom:10px !important;
        .img-wrap {
            height:auto;
            overflow:hidden;
            display:flex;
            justify-content:center;
            img {
                width:352px;
            }
        }
        .row-left,.row-right {
            width:100%;
            flex:auto !important;
        }
    }
    .content-wrap,.block-content-box {
      width:auto !important;
    }
    .content-wrap img {
      width:300px !important;
    }
    .explore-container {
    .layout-banner {
        height:380px !important;
        margin-top:108px;
        .pc-banner {
          display:none;
        }
        .mobile-banner {
          display:block !important;
          width:100%;
        }
        .title {
            font-size:24px !important;
            margin-bottom:10px !important;
        }
        .text-block {
            transform:translateY(0);
            margin-top:0;
            top:131px;
            left:60px;
            .desc {
              line-height:22px;
              }
        }
        .use-button {
            display:none;
        }
    }
     .block-wrap {
      width:calc(100% - 30px);
      margin:0;
      padding:25px 15px 0;
      .block-content {
        margin-top:32px;
        width:auto;
      }
        .block-title::after {
            top:40px;
        }
        .block-desc {
          padding:15px 15px 28px 15px;
          margin:0 ;
        }
    }
    }
    .mobile-airplane {
      display:block !important;
      margin-top:50px !important;
    }

    .pc-airplane {
      display:none !important;
    }


    .block-title {
      font-size:22px !important;
  }

    .block-text {
      padding:20px 0 20px !important;
      .title {
        margin-bottom:15px !important;
        font-size:18px !important;
        text-align:center;
      }
      .desc {
        font-size:15px !important;
        text-align:center;
      }
    }
    .block-content-bg {
      height:300px !important;
      margin-top:50px !important;
    }
    .block-content-title {
      font-size:22px !important;
    }
    .block-content-title::after {
            top:40px !important;
        }
        .desc-wrap {
          width:calc(100% - 30px) !important;
        }
}
</style>
